//
import Model from '@/models/Model'
import ProviderAccountBank from '@/models/Purchase/PchProviderAccountBank'

/**
* @class
*/
export default class PchProvider extends Model {

  //
  static appends = ['branch_offices']

  /**
   *
   */
  get branch_offices_address() {
    return this.branch_offices.map(({ address }) => address)
  }

  /**
   * { function_description }
   * @return     {<type>}  { description_of_the_return_value }
   */
  accountBank() {
    return this.hasMany(ProviderAccountBank)
  }

  /**
   * { function_description }
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'pch_provider'
  }

  /**
   * { function_description }
   * @param      {<type>}  data    The data
   * @return     {<type>}  { description_of_the_return_value }
   */
  accountBankCreate(data) {
    return this.$http.post(`${this.fullURL()}/pch_provider_account_bank`, data)
  }
}
